import en from "./en";

const languages: Record<string, unknown> = {};

languages.en = en;

export default languages;
